import { useRPCQuery } from "eddev/hooks"
import { useAuth } from "../useAuth"
import { AreaSpinner } from "@components/ui/Spinner"
import { formatShortDate } from "@utils/date-format"

type Props = {
  extended?: boolean
}

export function MembershipDetails(props: Props) {
  const auth = useAuth()
  const accountLookup = useRPCQuery(
    "api.memberships.getAccount",
    { jwt: auth.session?.access_token! },
    {
      staleTime: 1,
      refetchInterval: 0,
      enabled: auth.loggedIn,
    },
  )

  if (accountLookup.isPending) {
    return <AreaSpinner />
  }

  const self = accountLookup.data!

  return (
    <div className="stack-y-1">
      <div className="type-label-xs">Welcome back</div>
      <div className="type-title-s">
        {self.details.firstName} {self.details.lastName}
      </div>
      {self.membership && (
        <>
          <div className="flex gap-2 justify-between">
            <div className="stack-y-1">
              {self.membership.status === "active" ? (
                <>
                  <div className="type-label-m mb-1">
                    {self.membership.levelLabel} ({self.membership.typeLabel})
                  </div>
                  <div className="type-label-m-light">Until {formatShortDate(self.membership.renewalDate)}</div>
                </>
              ) : self.membership.status === "expired" ? (
                <>
                  <div className="type-body-m">
                    Your membership expired {formatShortDate(self.membership.renewalDate)}
                  </div>
                </>
              ) : null}
            </div>
          </div>
        </>
      )}
    </div>
  )
}
